/**
 * Normalize href / location strings for longest-prefix route matching.
 * Strips query + hash; ensures leading slash; trims trailing slash (except root).
 */
// eslint-disable-next-line import/prefer-default-export
export function pathPrefixFromHref(href: string): string {
  const raw = href.trim();
  if (!raw) return '/';
  const noHash = raw.split('#')[0] ?? raw;
  const noQuery = noHash.split('?')[0] ?? noHash;
  let path = noQuery.startsWith('/') ? noQuery : `/${noQuery}`;
  if (path.length > 1 && path.endsWith('/')) {
    path = path.slice(0, -1);
  }
  return path;
}
